import styled from 'styled-components';

export const SummaryToastContainer = styled.div<{ visible: boolean }>`
  display: flex;
  width: 342px;
  min-width: 300px;
  max-width: 400px;
  padding: 16px;
  align-items: flex-start;
  gap: 8px;
  border-radius: 4px;
  background-color: #ecfff8;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transform: translateY(${({ visible }) => (visible ? 0 : '8px')});
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
`;

export const SummaryToastText = styled.span`
  color: #2f2f31;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;
